import FullPageLoader from 'components/global/FullPageLoader'
import { SESSION_TYPE_MARCH_PROMO } from 'constants/app'
import { catchErrorByStatus } from 'helpers/errors'
import { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import {
    useGetSelfcareCartQuery,
    useListSelfcareOrderPositionsQuery,
} from 'store/api-slice/hooks'
import { useAppDispatch } from 'store/hooks'
import { setDeliveryType } from 'store/order-slice'
import {
    setSelfcareCart,
    setIsSelfcareCartCreated,
} from 'store/selfcare-cart-slice'
import {
    setPositions,
    setOrderId,
    setIsMarchPromoMode,
} from 'store/selfcare-slice'
import { useApp } from 'store/steps'

export const SelfcareDataWrapper: FC = ({ children }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { language, getPath } = useApp()

    const navigateToLoginPage = () => {
        navigate(getPath('selfcare_login'))
    }

    const {
        isFetching: isCartFetching,
        isError: isCartError,
        data: cartData,
        error: cartError,
    } = useGetSelfcareCartQuery({ _locale: language })

    const {
        isLoading: arePositionsLoading,
        isError: isPositionsError,
        data: positionsData,
        error: positionsError,
    } = useListSelfcareOrderPositionsQuery({ _locale: language })

    useEffect(() => {
        if (isCartFetching || !cartData) return
        const { cart } = cartData || {}
        const { items } = cart || {}

        dispatch(setSelfcareCart(cartData))

        if (items?.find((item) => item.productType === 'shipping')) {
            dispatch(setDeliveryType('shipping'))
        }
    }, [isCartFetching])

    useEffect(() => {
        if (arePositionsLoading) return

        if (isPositionsError) {
            if (positionsError && catchErrorByStatus({ error: positionsError }))
                return

            dispatch(setIsSelfcareCartCreated(false))
            navigateToLoginPage()
        } else if (positionsData) {
            dispatch(setIsSelfcareCartCreated(true))

            const { positions, orderId, sessionType } = positionsData
            positions && dispatch(setPositions(positions))
            orderId && dispatch(setOrderId(orderId))

            if (sessionType === SESSION_TYPE_MARCH_PROMO)
                dispatch(setIsMarchPromoMode(true))
        }
    }, [arePositionsLoading])

    useEffect(() => {
        if (isCartError && cartError) catchErrorByStatus({ error: cartError })
    }, [isCartError, cartError])

    if (arePositionsLoading) {
        return <FullPageLoader />
    }

    return <Outlet />
}
